/*
 * NOTE
 * The one place inside `constants/` that knows where the session store persists the shelter
 * profile.
 *
 * `activeDateFormat` and `activeShelterTimezone` both seed themselves from that blob at module
 * load, so a hard refresh never flashes a default before the profile refetch lands. Neither may
 * import `stores/session.ts` — the store imports `@Constants`, so the reverse direction would
 * close a cycle. Holding the key here keeps one copy for both readers instead of one each.
 *
 * The key still mirrors `stores/session.ts` (its STORE_BASE_NAME plus the `shelterProfile` key)
 * by hand. The store may import this file to build its own — that direction is safe — which
 * would remove the last hand-kept copy.
 * */

const SHELTER_PROFILE_STORAGE_KEY = 'af-session-store__shelter-profile';

function readPersistedShelterProfile(): Record<string, unknown> | null {
  const hasStorage = typeof localStorage !== 'undefined';
  if (!hasStorage) return null;

  try {
    const stored = localStorage.getItem(SHELTER_PROFILE_STORAGE_KEY);
    if (!stored) return null;

    const shelterProfile = JSON.parse(stored);
    const isObject = !!shelterProfile && typeof shelterProfile === 'object';

    return isObject ? shelterProfile : null;
  } catch {
    return null;
  }
}

export { readPersistedShelterProfile, SHELTER_PROFILE_STORAGE_KEY };
